<style scoped>
.content-wrapper .content {
    padding-top: 95px;
}

.el-select {
    display: block;
}

.el-icon-close {
    float: right;
    top: 7px !important;
}

.el-tag {
    width: 900px;
    display: block;
    margin-bottom: 10px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    text-align: left;
    direction: ltr;
}

.el-tag>i {
    float: right !important;
    top: 5px !important;
}

.fa.fa-external-link {
    transition: all 0.5s ease-out;
    visibility: hidden;
    opacity: 0;
}

.el-tag:hover .fa.fa-external-link {
    visibility: visible;
    opacity: 1;
}

.el-pagination {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
</style>
<template>
<!-- <transition name="el-zoom-in-top"> -->
<div class="content-wrapper">
    <section class="content">
        <div class="box">
            <div class="box-header with-border">
                <h3 class="box-title">Block URLS</h3>
            </div>
            <div class="box-header with-border">
                <h3 class="box-title">Search</h3>
                <el-input class="col-md-6" v-model="searchvalue" @keyup.enter.native="filterByEachInput" placeholder="search any urls" type="text">
                </el-input>
            </div>

            <div class="box-body">
                <form method="post" v-on:submit.prevent="" class="form">

                    <p>Add the URLS to be blocked here(each url on separate line)</p>

                    <el-input class="input-new-tag" v-if="inputVisible" v-model="inputValue" ref="saveTagInput" size="mini" type="textarea" @keyup.enter.native="handleInputConfirm" @blur="handleInputConfirm">
                    </el-input>
                    <el-button v-else class="button-new-tag" size="small" @click="showInput">+ Add URL</el-button>

                    <hr>

                    <div class="clearfix">
                        <div style="margin:0px 0px 10px 0px;">
                            <button type="button" class="el-button el-button--info" @click="onSubmit">
                                <i class="el-icon-plus el-icon-left"></i>
                                Save
                            </button>
                            <router-link to="/admin/domains/" class="el-button el-button--danger">
                                Cancel
                            </router-link>
                        </div>
                    </div>
                   
                        
                    <p v-if="dynamicTagsCopy.length != dynamicTags.length" style="color: red;float: right;font-style: italic;"><span style="font-size: 20px;">*</span> NOT SAVED</p>
                    <el-button  class="button-new-tag el-button--danger" size="small" style="float:right ;margin-left:10px" @click="openDeleteAllBlockUrlsModelBox(1)">Delete All blockedurls</el-button>
                    <el-button  class="button-new-tag " size="small" @click="deleteSelectedUrls(0)" style="float:right;margin-left:10px">Delete Selected blockedurls</el-button>
                    <div v-loading="loading">
                        <el-tag v-for="tag in dynamicTags" :disable-transitions="false" @close="handleClose(tag)">
                            <a :href="tag.url" target="_blank" style="display: inline-block;width: calc(100% - 50px);line-height: 30px;overflow: hidden;text-overflow: ellipsis;">
                                {{tag.url}}
                                <i class="fa fa-external-link" style="display: inline;margin-left: 5px;line-height: 30px;font-size: 20px;" aria-hidden="true"></i>
                            </a>
                             <span v-if="tag.id == undefined" style="color: red;font-size: 30px;">*</span>
                           
                            <input type="checkbox" style="float:right" :id='tag.id' :value="tag.id" v-model="selectedBlockurls">
                        </el-tag>
                    </div>
                    <el-pagination background layout="prev, pager, next" @current-change="handleCurrentChange" :pager-count="20" :current-page.sync="currentPage" :total="total_pages" :page-size="offset">
                    </el-pagination>
                    
                </form>
            </div>
        </div>
    </section>
</div>
</template>

<script>
import axios from 'axios';
export default {
    data: () => {
        return {
            data: [],
            searchvalue: '',
            dialogVisible: false,
            blockList: '',
            blockedBackend: '',
            name: undefined,
            publishers: [],
            loading: true,
            dynamicTags: [],
            dynamicTagsCopy: [],
             selectedBlockurls: [],
             visiblityModelBoxForDeleteAllBlockurls:false,
            inputVisible: false,
            inputValue: '',
            loading: true,
            currentPage: 1,
            total_pages: 0,
            offset: 20

        }
    },
    created: function () {
        this.getAllUrls();
    },
    methods: {
       
            openDeleteAllBlockUrlsModelBox() {
                this.$confirm('This will permanently delete all blocked urls. Continue?', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                    }).then(() => {
                    this.$message({
                        type: 'success',
                        message: 'Delete completed',
                         action:this.deleteSelectedUrls(1)
                        
                    });
                    }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: 'Delete canceled'
                    });          
                    });

          

        },
        deleteSelectedUrls(flag){
              var deleteUrl = BASE_URL + `v1/publisher/${this.$route.params.uuid}/domain/${this.$route.params.domId}/urls-delete/`;
            if (flag == 1) {
                var x = {
                    "blocked_urls": [],
                    "action": "all"
                }
            } else {
                if (this.selectedBlockurls.length == 0) {
                    this.$notify('error', 'error', "Please select blockedurls.", {
                        duration: 3000,
                        permanent: false
                    });
                    return;
                }
                var x = {

                    "blocked_urls": this.selectedBlockurls,
                    "action": "partial"
                }
            }

            axios.post(deleteUrl, x).then(res => {
                console.log(res);
                
                this.selectedBlockurls = [];
               this.getAllUrls(1);
                
            })

        },
        filterByEachInput() {
            console.log("searchvalue", this.searchvalue);
            axios.get(BASE_URL + `v1/UrlSearchApi/domain/${this.$route.params.domId}/?searchvalue=${this.searchvalue}`)
                .then(response => {
                    console.log("data", response);
                    this.dynamicTags = response.data.data;
                    this.total_pages = response.data.total;
                    this.loading = false;
                })
        },
        getAllUrls(pageNum) {
            this.loading = true;
            console.log("hgghuhihiuh============", pageNum);
            if (pageNum == undefined) {
                pageNum = 1;
            }
            axios.all([
                    axios.get(BASE_URL + `v1/publisher/${this.$route.params.uuid}/domain/${this.$route.params.domId}/urls/?page=${pageNum}&offset=${this.offset}`)
                ])
                .then(axios.spread(response => {
                    this.dynamicTagsCopy = JSON.parse(JSON.stringify(response.data));
                    this.dynamicTags = response.data.data;
                    this.total_pages = response.data.total;
                    this.loading = false;
                }));
        },
        handleClose(done) {
            this.$confirm('Are you sure to close this dialog?')
                .then(_ => {
                    done();
                    this.loading = false;
                })
                .catch(_ => {});
        },
        onSubmit() {
            let urls = [];
            this.dynamicTags.forEach((url) => {
                if (!url.id) {
                    urls.push({
                        'domain': this.$route.params.domId,
                        'url': url.url
                    });
                    axios.post(BASE_URL + 'v1/publisher/' + this.$route.params.uuid + '/domain/' + this.$route.params.domId + '/urls/', {
                            'domain': this.$route.params.domId,
                            'url': url.url
                        })
                        .then(response => {
                            console.log(response);
                            this.getAllUrls();
                        })
                        .catch(error => {});
                }
                console.log(urls);
            });

        },
        handleClose(tag) {
            this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
        },
        showInput() {
            this.inputVisible = true;
            this.$nextTick(_ => {
                this.$refs.saveTagInput.$refs.input.focus();
            });
        },
        isValidUrl(string) {
            try {
                new URL(string);
                return true;
            } catch (_) {
                return false;
            }
        },
        handleCurrentChange(val) {
            console.log("Current page#####################", val);
            this.getAllUrls(val);

        },

        handleInputConfirm() {
            let inputValue = this.inputValue;
            // console.log(inputValue);
            let inputValues = inputValue.split('\n');
            console.log(inputValues);
            var patt = new RegExp("^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[/?#]\S*)?$");

            inputValues.forEach((val) => {
                if (this.isValidUrl(val.trim()))
                    this.dynamicTags.push({
                        'url': val.trim()
                    });
            })
            // if (inputValue) {
            // 	this.dynamicTags.push({'url': inputValue});
            // }
            this.inputVisible = false;
            this.inputValue = '';
        },
        deleteUrl(tagId) {
            console.log(tagId);
            axios.delete(BASE_URL + 'v1/publisher/' + this.$route.params.uuid + '/domain/' + this.$route.params.domId + '/urls/' + tagId)
                .then(response => {
                    console.log(response);
                    // this.getAllUrls();
                    this.dynamicTags = this.dynamicTags.filter((url) => {
                        return url.id != tagId;
                    })
                })
                .catch(error => {});
        }
    }
};
</script>



// WEBPACK FOOTER //
// BlockUrls.vue?7859e701